import { LayoutModule } from '../../layout/modules';
import { UserFilters } from './filters';
import UserList from './list';
import { useState } from 'react';
import { HOME, USERNEW } from '../../../routes/paths';
import { UserFilter } from '../../../shared/types/user';
import LoadingButtonGeneral from '../../components/general/buttons/loadingButtonGeneral';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

export const Users = () => {
    const [filters, setFilters] = useState<UserFilter>();
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    return (
        <>
            <LayoutModule
                title="Listado usuarios"
                {...(type === 'admin' && { createPath: USERNEW })}
                additionalButtons={
                    <LoadingButtonGeneral
                        variant="outlined"
                        title="Volver"
                        sx={{ mr: 1 }}
                        onClick={() => navigate(HOME)}
                        startIcon={<ArrowBackIcon />}
                    />
                }
            >
                <UserFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <UserList filters={filters} />
        </>
    );
};
